module.exports = __webpack_public_path__ + "img/right1.ee39c4ed.png";